import * as Yup from "yup"

const emailValidation = Yup.string().email("Invalid email").required("Required")
const passwordValidation = Yup.string()
  .required("Required")
  .min(6, "Password is too short - should be 6 chars minimum.")
  .matches(/[a-zA-Z]/, "Password can only contain Latin letters.")
  //.matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,}$/, 'Password must have at least one letter, one number and one special character')

const nameValidation = (errorMessages: IErrorMessages = {}) =>
  Yup.string()
    .required(errorMessages.required || "Required")
    .matches(/^[A-Za-z ]*$/, errorMessages.matches || "Can contain only letters")
    .max(50, errorMessages.max || "Must not be more than 50 characters")

const usernameValidation = Yup.string()
  .required("Required")
  .min(4, "Must be at least 4 characters")
  .max(50, "Must not be more than 50 characters")
  .matches(/^[A-Za-z0-9]*$/, "Can contain only letters and numbers")

export const signUpValidationSchema = Yup.object().shape({
  username: usernameValidation,
  firstName: nameValidation(),
  lastName: nameValidation(),
  email: emailValidation,
  password: passwordValidation,
})

export const providerSignUpValidationSchema = Yup.object().shape({
  username: usernameValidation,
  firstName: nameValidation(),
  lastName: nameValidation(),
  email: emailValidation,
})

export const questionValidator = (id: string) => Yup.object().shape({
  [id]: Yup.string().required()
})

interface IErrorMessages {
  required?: string
  matches?: string
  max?: string
}
